<!--
  File name: ActionModal.vue
  Program Description:
    - This component displays the generic modal for all action throughout the
    system.
    - When accessed, it displays the title, the message, and the actions
    that can be clicked by the user depending on the feature.
    - Used in PBNEF form for endorsement
-->

<template>
  <v-dialog
    v-model="cDialog"
    max-width="600"
    content-class="dialog"
    persistent
  >
    <v-card
      tile
      style="padding:10px;"
      max-height="50vh"
    >
      <v-card-title
        v-if="title"
        class="headline primary--text"
      >
        {{ title }}
      </v-card-title>
      <v-card-text v-if="message">
        {{ message }}
      </v-card-text>
      <div style="padding: 20px;">
        <component
          :is="child"
          v-model="selected"
          v-bind="vBind"
        />
      </div>
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          @click="$emit('dialog', false)"
        >
          Cancel
        </v-btn>
        <v-btn
          v-if="priv"
          class="px-6"
          :color="buttonColor"
          @click="$emit('callback', selected)"
        >
          {{ buttonLabel }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { LookUpSelect } from 'maroon-vue-components'
import { VTextField, VCombobox, VSelect, VRadioGroup, VRadio } from 'vuetify/lib'
export default {
  components: {
    LookUpSelect,
    VTextField,
    VCombobox,
    VSelect,
    VRadioGroup,
    VRadio
  },
  props: {
    dialog: Boolean,
    value: { type: String, default: undefined },
    title: { type: String, default: undefined },
    message: { type: Object, default: undefined },
    priv: {
      type: Boolean,
      default: true
    },
    buttonLabel: {
      type: String,
      default: 'Proceed'
    },
    buttonColor: {
      type: String,
      default: 'red darken-1'
    },
    callback: {
      type: Function,
      default: () => {}
    },
    child: { type: String, default: undefined },
    vBind: { type: Object, default: undefined },
    // eslint-disable-next-line vue/prop-name-casing
    'error-messages': { type: Array, default: undefined }
  },
  computed: {
    selected: {
      get: function () {
        return this.$props.value
      },
      set: function (newVal) {
        this.$emit('input', newVal)
      }
    },
    cDialog: {
      get: function () {
        return this.$props.dialog
      },
      set: function () {}
    }
  }
}
</script>
